// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAH2Ok3L_znKeh5jgSxSu8kD9-4KSu1jec",
  authDomain: "react-app-1fdd3.firebaseapp.com",
  projectId: "react-app-1fdd3",
  storageBucket: "react-app-1fdd3.appspot.com",
  messagingSenderId: "538238613796",
  appId: "1:538238613796:web:3e9db7fed39800912d9bb1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app)
export const googleProvider = new GoogleAuthProvider()
export default app;